import { render, staticRenderFns } from "./ProduktionsVerfahrenSelect.vue?vue&type=template&id=36a57f6b"
import script from "./ProduktionsVerfahrenSelect.vue?vue&type=script&lang=js"
export * from "./ProduktionsVerfahrenSelect.vue?vue&type=script&lang=js"
import style0 from "./ProduktionsVerfahrenSelect.vue?vue&type=style&index=0&id=36a57f6b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports